import * as types from '../constants/idpAdminActions';
import * as messages from '../shared/messages';
import Moment from 'moment';

const initialState = {
  issuerUrl: null,
  singleSignOnRedirectUrl: null,
  singleSignOnPostUrl: null,
  singleLogoutRedirectUrl: null,
  singleLogoutPostUrl: null,
  publicKeyPemCertificate: null,
  fetchingCreateIdp: null,
  getIdpMetadataInProgress: false,
  idpMetadata: null,
  certificateValidTo: null,
  newCertificateValidTo: null,
  oidcMetadataUrl: null,
  oidcIssuerUrl: null,
  oidcAuthorizeEndpointUrl: null,
  oidcTokenEndpointUrl: null,
  oidcUserInfoEndpointUrl: null,
  oidcIntrospectionEndpointUrl: null,
  oidcLogoutEndpointUrl: null,
  getOidcIdpMetadataInProgress: false,
  showModalOidcIdpMetadata: false,
  wsFedIssuerUrl: null,
  wsFedPassiveUrl: null,
  wsFedActiveUrl: null,
  wsFedMetadataUrl: null,
  wsFedLogoffUrl: null,
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_IDP_METADATA_START:
      return Object.assign({}, state, {
        getIdpMetadataInProgress: true,
      });

    case types.GET_IDP_METADATA_SUCCESS:
      return Object.assign({}, state, {
        issuerUrl: action.idpMetadata.issuerUrl,
        singleSignOnRedirectUrl: action.idpMetadata.singleSignOnRedirectUrl,
        singleSignOnPostUrl: action.idpMetadata.singleSignOnPostUrl,
        singleLogoutRedirectUrl: action.idpMetadata.singleLogoutRedirectUrl,
        singleLogoutPostUrl: action.idpMetadata.singleLogoutPostUrl,
        publicKeyPemCertificate: action.idpMetadata.publicKeyPemCertificate,
        errorMsg: null,
        getIdpMetadataInProgress: false,
        showModalCopyUrl: true,
        certificateValidTo: Moment.utc(action.idpMetadata.certificateValidTo),
        newCertificateValidTo: Moment.utc(action.idpMetadata.newCertificateValidTo),
        oidcMetadataUrl: action.idpMetadata.oidcIssuerUrl,
        wsFedIssuerUrl: action.idpMetadata.wsFedIssuerUrl,
        wsFedPassiveUrl: action.idpMetadata.wsFedPassiveUrl,
        wsFedActiveUrl: action.idpMetadata.wsFedActiveUrl,
        wsFedMetadataUrl: action.idpMetadata.wsFedMetadataUrl,
        wsFedLogoffUrl: action.idpMetadata.wsFedLogoffUrl,
      });

    case types.GET_IDP_METADATA_FAIL:
      return {
        ...state,
        errorMsg: messages.GENERIC_ERROR,
        getIdpMetadataInProgress: false,
        showModalIdpMetadata: false
      };

    case types.CLEAR_MESSAGES:
      return {
        ...state,
        errorMsg: null,
        idpErrorMsg: null,
        successMsg: null
      };

    case types.SHOW_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalIdpMetadata: true,
      };
    case types.HIDE_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalIdpMetadata: false,
      };
    case types.GET_OIDC_IDP_METADATA_START:
      return {
        ...state,
        getOidcIdpMetadataInProgress: true,
      };

    case types.GET_OIDC_IDP_METADATA_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        getOidcIdpMetadataInProgress: false,
        oidcIssuerUrl: action.oidcIdpMetadata.issuer,
        oidcAuthorizeEndpointUrl: action.oidcIdpMetadata.authorization_endpoint,
        oidcTokenEndpointUrl: action.oidcIdpMetadata.token_endpoint,
        oidcUserInfoEndpointUrl: action.oidcIdpMetadata.userinfo_endpoint,
        oidcIntrospectionEndpointUrl: action.oidcIdpMetadata.introspection_endpoint,
        oidcLogoutEndpointUrl: action.oidcIdpMetadata.end_session_endpoint
      };

    case types.GET_OIDC_IDP_METADATA_FAIL:
      return {
        ...state,
        errorMsg: messages.GENERIC_ERROR,
        getOidcIdpMetadataInProgress: false,
        showModalOidcIdpMetadata: false
      };

    case types.SHOW_OIDC_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalOidcIdpMetadata: true,
      };
    case types.HIDE_OIDC_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalOidcIdpMetadata: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/idp.js